export const BrandMark = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid="brand-mark"
    className="group inline-flex items-center gap-2 outline-none focus-visible:ring-1 focus-visible:ring-stardust/50 rounded px-2 py-1"
  >
    <span className="text-stardust text-base leading-none">✦</span>
    <span className="heading-serif text-xl text-[#F5EBD8] tracking-tight">
      Astrarium<span className="text-stardust">.</span>
    </span>
  </button>
);
